import { render, staticRenderFns } from "./infancy.vue?vue&type=template&id=80c1216c&scoped=true"
import script from "./infancy.vue?vue&type=script&lang=js"
export * from "./infancy.vue?vue&type=script&lang=js"
import style0 from "./infancy.vue?vue&type=style&index=0&id=80c1216c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c1216c",
  null
  
)

export default component.exports